/**
 * @jest-environment jsdom
 */
import React from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { AmbassadorChallengeDetails } from '../AmbassadorChallengeDetails/AmbassadorChallengeDetails.component'
import { AmbassadorProfile } from '../AmbassadorProfile/AmbassadorProfile.component'
import 'react-tabs/style/react-tabs.less'

interface tabs extends FunctionsToProps {
  data: ChallengeDataRecord;
  onAfterSocialShare?: any;
  toggleModal?: () => void;
  ambassadorProfile: AmbassadorProfileRecord;
  onAmbssadorProfile: boolean;
}

interface FunctionsToProps {
  getConvertedCurrencyValue: (value: number) => string;
  getDaysRemaining: (EndDate: string) => string;
  getPercentageFunded: (currentValue: number, goalvalue: number) => number;
}

export function GetTabs(props: tabs) {
  return (
    <Tabs defaultIndex={props.onAmbssadorProfile ? 0 : 1}>
      <TabList>
        {props.data.CreatedBy !== null && (
          <Tab tabIndex="0" data-test="tab-one">
            <span className="tablTitle profile">Ambassador Profile</span>
          </Tab>
        )}
        <Tab
          tabIndex="1"
          data-test="tab-two"
        >
          <span className="tablTitle challengeDetails">Challenge Details</span>
        </Tab>
      </TabList>

      {props.data.CreatedBy !== null && (
        <TabPanel>
          <AmbassadorProfile
            toggleModal={props.toggleModal}
            ambassadorProfile={props.ambassadorProfile}
          />
        </TabPanel>
      )}
      <TabPanel>
        <AmbassadorChallengeDetails
          data={props.data}
          getPercentageFunded={props.getPercentageFunded}
          key={0}
          onAfterSocialShare={props.onAfterSocialShare}
          getConvertedCurrencyValue={props.getConvertedCurrencyValue}
          getDaysRemaining={props.getDaysRemaining}
          toggleModal={props.toggleModal}
        />
      </TabPanel>
    </Tabs>
  )
}
